import React from 'react';
export function CtaSection() {
  const handleClick = () => {
    window.open("https://gr-16052026.myshopify.com/cart/45060107894838:1", "_blank");
  };
  return <div style={{
    backgroundColor: '#09090b',
    padding: '80px 20px',
    textAlign: 'center',
    borderTop: '1px solid #27272a'
  }} data-id="element-9">
      <div style={{
      maxWidth: '600px',
      margin: '0 auto'
    }} data-id="element-10">
        <span style={{
        color: '#71717a',
        textDecoration: 'line-through',
        fontSize: '24px'
      }} data-id="element-11">$197</span>
        <h2 style={{
        color: '#3b82f6',
        fontSize: '64px',
        fontWeight: '900',
        margin: '10px 0'
      }} data-id="element-12">$47</h2>
        <p style={{
        color: '#a1a1aa',
        letterSpacing: '2px',
        fontWeight: 'bold',
        marginBottom: '40px'
      }} data-id="element-13">PAGO ÚNICO • ACCESO DE POR VIDA</p>
        
        <button onClick={handleClick} style={{
        width: '100%',
        backgroundColor: '#2563eb',
        color: 'white',
        padding: '24px',
        fontSize: '24px',
        fontWeight: '900',
        borderRadius: '12px',
        border: 'none',
        cursor: 'pointer',
        boxShadow: '0 0 20px rgba(37, 99, 235, 0.5)',
        textTransform: 'uppercase'
      }} data-id="element-14">
          OBTENER ACCESO INMEDIATO
        </button>
        
        <p style={{
        color: '#22c55e',
        marginTop: '20px',
        fontWeight: 'bold'
      }} data-id="element-15">✓ Garantía de 30 días sin riesgo</p>
      </div>
    </div>;
}